import React from 'react';
import { Link } from 'react-router-dom';

export const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-container">
        <div className="hero-box">
          <div className="hero-center">
            <h3
              // data-w-id="92f0cc8f-fd6a-6cf4-2f16-2b23880cada0"
              style={{ opacity: 1 }}
              className="heading-italic"
            >
              The best version of you starts here
            </h3>
            <h1
              // data-w-id="a67385c1-53ce-c13d-66a5-09c83ff80c93"
              style={{ opacity: 1 }}
              className="hero-h1"
            >
              Go beyond routine, Find your flow
            </h1>
            <div
              // data-w-id="422a2023-0550-c073-e22b-cd796c4ab55d"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="hero-p">
                Discover experiences that energize your day and elevate your
                lifestyle.
              </p>
            </div>
            <Link
              // data-w-id="bf54271f-b5e7-4b6c-6f43-11d7df375ca5"
              style={{ opacity: 1 }}
              to="/categories"
              className="cta-button w-inline-block"
            >
              <div className="text-block">Explore</div>
            </Link>
          </div>
          <div
            // data-w-id="a8a57870-34a1-f445-76d6-6bfc3e41b6aa"
            style={{ opacity: 1 }}
            className="hero-bottom"
          >
            <img
              src="/images/bg-edited.svg"
              loading="lazy"
              alt="Hobi - Go beyond routine, Find your flow"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
